export function canOpenCamera(): boolean {
  return typeof navigator !== "undefined" && !!navigator.mediaDevices?.getUserMedia;
}

export function openCameraStream(): Promise<MediaStream> {
  return navigator.mediaDevices.getUserMedia({
    audio: false,
    video: {
      facingMode: { ideal: "environment" },
      height: { ideal: 1440 },
      width: { ideal: 1920 },
    },
  });
}

export function stopCameraStream(stream: MediaStream | null): void {
  for (const track of stream?.getTracks() ?? []) track.stop();
}

/** With `aspect`, keeps the centered crop a `cover` viewfinder shows. */
export function captureVideoFrame(
  video: HTMLVideoElement,
  aspect?: number,
): Promise<File | null> {
  const { videoWidth: sourceWidth, videoHeight: sourceHeight } = video;
  if (sourceWidth === 0 || sourceHeight === 0) return Promise.resolve(null);
  const target = aspect ?? sourceWidth / sourceHeight;
  const width = Math.round(Math.min(sourceWidth, sourceHeight * target));
  const height = Math.round(width / target);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) return Promise.resolve(null);
  ctx.drawImage(
    video,
    (sourceWidth - width) / 2,
    (sourceHeight - height) / 2,
    width,
    height,
    0,
    0,
    width,
    height,
  );
  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) =>
        resolve(
          blob ? new File([blob], `photo-${Date.now()}.jpg`, { type: "image/jpeg" }) : null,
        ),
      "image/jpeg",
      0.9,
    );
  });
}
